import React from 'react';
import './style.scss';
import {APP_ROUTES} from '../../constants';
import {NavLink} from 'react-router-dom';
import bottomNavGame from '../../../images/bottom-nav-game.png';
import bottomNavRating from '../../../images/bottom-nav-rating.png';
import bottomNavFriends from '../../../images/bottom-nav-friends.png';

const ActiveItemBackground = () => <svg width="42" height="43" viewBox="0 0 42 43" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g filter="url(#filter0_f_3262_829)">
    <circle cx="21" cy="21.5" r="13" fill="#87FF85" fillOpacity="0.54"/>
  </g>
  <defs>
    <filter id="filter0_f_3262_829" x="0" y="0.5" width="42" height="42" filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB">
      <feFlood floodOpacity="0" result="BackgroundImageFix"/>
      <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
      <feGaussianBlur stdDeviation="4" result="effect1_foregroundBlur_3262_829"/>
    </filter>
  </defs>
</svg>;

export const BottomNav = () => {
  return <div className="app-bottom-nav">
    <NavLink to={APP_ROUTES.HOME} className="app-bottom-nav-item">
      <ActiveItemBackground/>
      <img src={bottomNavGame} alt={''}/>
      <span>Игра</span>
    </NavLink>
    <NavLink to={APP_ROUTES.RATING} className="app-bottom-nav-item">
      <ActiveItemBackground/>
      <img src={bottomNavRating} alt={''}/>
      <span>Рейтинг</span>
    </NavLink>
    <NavLink to={APP_ROUTES.FRIENDS} className="app-bottom-nav-item">
      <ActiveItemBackground/>
      <img src={bottomNavFriends} alt={''}/>
      <span>Друзья</span>
    </NavLink>
  </div>;
}